export enum ContactType {
    Address = "postalAddress",
    Email = "email",
    PhoneNumber = "phoneNumber",
}
